exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab_ul[data-v-7c16f911]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:0 10px}.tab_ul .tab_li[data-v-7c16f911]{text-align:center;padding:10px 0;margin-right:30px;font-weight:700;font-size:15px;border-bottom:2px solid transparent;cursor:pointer}.tab_ul .tab_li.active_nav[data-v-7c16f911]{color:#ec1c1c;border-bottom:2px solid #ec1c1c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c16f911","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/nav-tab/navTab.vue
// module id = Uh+H
// module chunks = 27 29 103